const GraphQLForm = require('app/graphql/Form');
const ConfirmModal = require('app/ui/modal/Confirm');
const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');

class Form extends GraphQLForm {

    defaultOptions(){
        var options = {
            'mutationType': 'SubmitSupplierProduct',
            'rangeOptionOffset': '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            'product': {
                'id': '',
                'number': '',
                'reference': '',
                'description': '',
                'unit': '',
                'quantity': '',
                'weight': '',
                'status': 0,
                'range': { 'id': null },
                'supplier': { 'id': null, 'sectors': []  },
                'supplierPrice': '',
                'supplierPriceViewable': '',
                'price': '',
                'tva': '',
                'taxAssociations': [],
                'sectorPriceUpdates': [],
                'technicalFile': null,
            },
            'suppliers': [],
            'taxs': [],
            'ranges': [],
        };
        return Object.assign(super.defaultOptions(),options);
    }

    initialize() {
        var self = this;

        this.product = this.settings.product;

        this.createMode = true;
        if(this.product.id){
            this.createMode = false;
        }

        this.$form = $('<form/>')
        .addClass('product-info-form');

        this.loadData();

        super.initialize();
    }

    getProduct(){
        return this.product;
    }

    getForm(){
        return this.$form;
    }

    refresh(){
        this.loadData();
    }

    loadData(){
        var self = this;

        this.$form.html('');

        let queries = [
            this.buildSupplierQuery(),
            this.buildRangeQuery(),
            this.buildTaxQuery(),
        ];

        if(this.product.id){
            queries.push(this.buildProductQuery());
        }

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillForm(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildProductQuery(){
        var self = this;

        let id = this.product.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'number',
            'reference',
            'description',
            'unit',
            'quantity',
            'weight',
            'status',
            'range { id }',
            'supplier { id }',
            'supplierPrice',
            'supplierPriceViewable',
            'price',
            'tva',
            'taxAssociations { amountPerUnit tax { id } }',
            'sectorPriceUpdates { sector { id } price }',
            'technicalFile { url }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProduct',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }


    buildSupplierQuery(){
        var self = this;


        let filters = {
            'enable': true,
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
            'sectors { id name }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'suppliers',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildRangeQuery(){
        var self = this;


        let filters = {
            'root': true,
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'filter': filters,
            'orderBy': 'name',
            'dir': 'ASC',
        };

        let fields = [
            'id',
            'name',
            'childs { id name parent { id } childs { id name parent { id } childs { id name parent { id } } } }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProductRanges',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    buildTaxQuery(){
        var self = this;


        let filters = {
        };

        let parameters = {
            'first': 10000,//to be sure to have all
            'orderBy': 'name',
            'dir': 'ASC',
            'filter': filters,
        };

        let fields = [
            'id',
            'name',
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'taxs',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    fillForm(data){
        if(data.supplierProduct){
            this.product = data.supplierProduct;
        }
        this.suppliers = data.suppliers.edges;
        this.ranges = data.supplierProductRanges.edges;
        this.taxs = data.taxs.edges;

        this.$btnSubmit = $('<button/>')
        .attr('type','submit')
        .addClass('btn btn-success');

        if(this.product.id){
            this.$btnSubmit.append(window.translate('app.product.show.tabs.info.infoForm.submit.label'));
        }else{
            this.$btnSubmit.append(window.translate('app.product.create.submit.label'));
        }

        this.$form
        .append(
            $('<div/>')
            .addClass('row')
            .append(this.buildGeneralCol())
            .append(this.buildPriceCol())
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append(this.$btnSubmit)
            )
        );


        this.$supplierSelect.trigger("change");

        return this.$form;
    }

    getFields(){
        let fields = super.getFields();
        fields.push('product { id }');
        return fields;
    }
    
    getVariables(){
        let variables = {};

        if(this.isCopy()){
            variables.copyFrom = {
                'value': this.product.id,
                'type': 'Int'
            }

        }else if(this.product.id){
            variables.product = {
                'value': this.product.id,
                'type': 'Int'
            }
        }

        return variables;
    }

    isCopy(){
        return this.settings.copyMode;
    }

    buildGeneralCol(){
        var self = this;
        let $col = $('<div/>')
        .addClass('col-6 p-2');

        let $box = $('<div/>')
        .addClass('white-box')
        .appendTo($col);


        let number = this.product.number;
        let reference = this.product.reference;
        let description = this.product.description;
        let unit = this.product.unit;
        let quantity = this.product.quantity;
        let weight = this.product.weight;
        let status = this.product.status;
        let range = this.product.range.id;
        let supplier = this.product.supplier.id;

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.product.show.tabs.info.infoForm.label'))
        .appendTo($box);

        //FIELD number
        let $numberLabel = $('<label/>')
        .attr('for','number')
        .append(window.translate('app.product.show.tabs.info.infoForm.number.label'));
        this.$inputNumber = $('<input/>')
        .attr('type','text')
        .attr('name','number')
        .addClass('form-control')
        .val(number);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($numberLabel)
            .append(this.$inputNumber)
        )

        //FIELD reference
        let $referenceLabel = $('<label/>')
        .attr('for','reference')
        .append(window.translate('app.product.show.tabs.info.infoForm.reference.label'));
        this.$inputReference = $('<input/>')
        .attr('type','text')
        .attr('name','reference')
        .addClass('form-control')
        .attr('required','required')
        .val(reference);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($referenceLabel)
            .append(this.$inputReference)
        )

        //FIELD description
        let $descriptionLabel = $('<label/>')
        .attr('for','description')
        .append(window.translate('app.product.show.tabs.info.infoForm.description.label'));
        this.$inputDescription = $('<textarea/>')
        .attr('type','text')
        .attr('name','description')
        .attr('rows',3)
        .addClass('form-control')
        .append(description);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($descriptionLabel)
            .append(this.$inputDescription)
        )


        //FIELD quantity
        let $quantityLabel = $('<label/>')
        .attr('for','quantity')
        .append(window.translate('app.product.show.tabs.info.infoForm.quantity.label'));
        this.$inputQuantity = $('<input/>')
        .attr('type','text')
        .attr('name','quantity')
        .addClass('form-control')
        .attr('required','required')
        .val(quantity);

        //FIELD unit
        let $unitLabel = $('<label/>')
        .attr('for','unit')
        .append(window.translate('app.product.show.tabs.info.infoForm.unit.label'));
        this.$unitSelect = $('<select/>')
        .attr('name','unit')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );
        let units = window.App.get('units');
        for(var value in units){
            let label = units[value];

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(this.product.unit == value){
                $option.attr('selected','selected');
            }
            this.$unitSelect.append($option);
        }


        let $packagingLabel = $('<label/>')
        .append(window.translate('app.product.show.tabs.info.infoForm.packaging.label'));
        let $packagingContainer = $('<div/>')
        .addClass('row');


        $packagingContainer
        .append(
            $('<div/>')
            .addClass('col-6')
            .append(
                $('<div/>')
                .addClass('form-group')
                .append($quantityLabel)
                .append(this.$inputQuantity)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-6')
            .append(
                $('<div/>')
                .addClass('form-group ms-1')
                .append($unitLabel)
                .append(this.$unitSelect)
            )
        );

        $box
        .append(
            $('<div/>')
            .addClass('form-group')
            .append($packagingLabel)
            .append($packagingContainer)
        )

        
        //FIELD weight
        let $weightLabel = $('<label/>')
        .attr('for','quantity')
        .append(window.translate('app.product.show.tabs.info.infoForm.weight.label'));
        this.$inputWeight = $('<input/>')
        .attr('type','text')
        .attr('name','weight')
        .addClass('form-control')
        .attr('required','required')
        .val(weight);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($weightLabel)
            .append(this.$inputWeight)
        );

        //FIELD status
        let $statusLabel = $('<label/>')
        .attr('for','status')
        .append(window.translate('app.product.show.tabs.info.infoForm.status.label'));
        this.$statusSelect = $('<select/>')
        .attr('name','status')
        .addClass('form-control')
        .attr('required','required');
        let statuses = window.App.get('productStatus');
        for(var value in statuses){
            let label = statuses[value];

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(this.product.status == value){
                $option.attr('selected','selected');
            }
            this.$statusSelect.append($option);
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($statusLabel)
            .append(this.$statusSelect)
        );


        //FIELD technicalFile
        let $technicalFileLabel = $('<label/>')
        .attr('for','technicalFile')
        .append(window.translate('app.product.show.tabs.info.infoForm.technicalFile.label'));
        this.$inputTechnicalFile = $('<input/>')
        .attr('type','file')
        .attr('accept','application/pdf')
        .attr('name','technicalFile')
        .addClass('form-control');
        let $technicalFileContainer = $('<div/>')
        .addClass('form-group')
        .append($technicalFileLabel)
        .append(this.$inputTechnicalFile);
        if(this.product.technicalFile){
            let $technicalFileLink = $('<a/>')
            .attr('href',window.App.get('apiBaseUrl')+this.product.technicalFile.url)
            .addClass('btn btn-primary me-1')
            .attr('target','_blank')
            .append(
                $('<i/>')
                .addClass('fas fa-file-pdf me-1')
            )
            .append(window.translate('app.product.show.tabs.info.infoForm.technicalFile.show.label'));


            let $btnDeleteTechnicalFile = $('<button/>')
            .attr('type','button')
            .addClass('btn btn-danger ms-1')
            .append(
                $('<i/>')
                .addClass('fas fa-trash me-1')
            )
            .append(window.translate('app.product.show.tabs.info.infoForm.technicalFile.delete.label'))
            .on('click',function(){
                self.onClickDeleteTechnicalFile();
            });

            $technicalFileContainer
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center mt-1')
                .append($technicalFileLink)
                .append(' ')
                .append($btnDeleteTechnicalFile)
            );
        }
        $box.append($technicalFileContainer);

        //FIELD range
        let $rangeLabel = $('<label/>')
        .attr('for','range')
        .append(window.translate('app.product.show.tabs.info.infoForm.range.label'));
        this.$rangeSelect = $('<select/>')
        .attr('name','range')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );
        for(var r in this.ranges){
            let range = this.ranges[r].node;

            let options = this.buildRangeOptions(range);
            for(var o in options){
                let $option = options[o];
                if($option.val() == this.product.range.id){
                    $option.attr('selected','selected');
                }
                this.$rangeSelect.append($option);
            }
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($rangeLabel)
            .append(this.$rangeSelect)
        );


        //FIELD supplier
        let $supplierLabel = $('<label/>')
        .attr('for','supplier')
        .append(window.translate('app.product.show.tabs.info.infoForm.supplier.label'));
        this.$supplierSelect = $('<select/>')
        .attr('name','supplier')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        )
        .on('change',function(event){
            self.onChangeSupplier();
        });

        for(var i in this.suppliers){
            let supplierItem = this.suppliers[i];

            let value = supplierItem.node.id;
            let label = supplierItem.node.name;

            let $option = $('<option/>')
            .val(value)
            .append(label);

            if(this.product.supplier.id == value){
                $option.attr('selected','selected');
            }

            this.$supplierSelect.append($option);

        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($supplierLabel)
            .append(this.$supplierSelect)
        );


        return $col;
    }

    buildRangeOptions(range,offset){
        let options = [];

        if(!offset){
            offset = '';
        }

        let $option = $('<option/>')
        .val(range.id)
        .append(offset + range.name);

        if(range.parent == null){
            $option.addClass('fw-bold');
        }

        options.push($option);
        if(range.childs && range.childs.length > 0){
            for(var c in range.childs){
                var child = range.childs[c];
                let childOptions = this.buildRangeOptions(child,offset+this.settings.rangeOptionOffset);
                for(var o in childOptions){
                    let $childOption = childOptions[o];
                    options.push($childOption);
                }
            }
        }

        return options;
    }


    buildPriceCol(){
        let $col = $('<div/>')
        .addClass('col-6 p-2');

        let $box = $('<div/>')
        .addClass('white-box')
        .appendTo($col);

        let supplierPrice = this.product.supplierPrice ? parseFloat(this.product.supplierPrice) : '';
        let supplierPriceViewable = this.product.supplierPriceViewable ? parseFloat(this.product.supplierPriceViewable) : '';
        let price = this.product.price ? parseFloat(this.product.price) : '';
        let tva = this.product.tva ? parseFloat(this.product.tva) : '';
        let taxAssociations = this.product.taxAssociations;

        //LABEL
        let $label = $('<h3/>')
        .addClass('box-title')
        .append(window.translate('app.product.show.tabs.info.priceForm.label'))
        .appendTo($box);


        //FIELD supplierPrice
        let $supplierPriceLabel = $('<label/>')
        .attr('for','supplierPrice')
        .append(window.translate('app.product.show.tabs.info.priceForm.supplierPrice.label'));
        this.$inputSupplierPrice = $('<input/>')
        .attr('type','text')
        .attr('name','supplierPrice')
        .addClass('form-control')
        .attr('required','required')
        .val(supplierPrice);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($supplierPriceLabel)
            .append(this.$inputSupplierPrice)
        )

        //FIELD supplierPriceViewable
        let $supplierPriceViewableLabel = $('<label/>')
        .attr('for','supplierPriceViewable')
        .append(window.translate('app.product.show.tabs.info.priceForm.supplierPriceViewable.label'));
        this.$inputSupplierPriceViewable = $('<input/>')
        .attr('type','text')
        .attr('name','supplierPriceViewable')
        .addClass('form-control')
        .attr('required','required')
        .val(supplierPriceViewable);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($supplierPriceViewableLabel)
            .append(this.$inputSupplierPriceViewable)
        )

        //FIELD price
        let $priceLabel = $('<label/>')
        .attr('for','price')
        .append(window.translate('app.product.show.tabs.info.priceForm.price.label'));
        this.$inputPrice = $('<input/>')
        .attr('type','text')
        .attr('name','price')
        .addClass('form-control')
        .attr('required','required')
        .val(price);
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($priceLabel)
            .append(this.$inputPrice)
        )

        //FIELD tva
        let $tvaLabel = $('<label/>')
        .attr('for','tva')
        .append(window.translate('app.product.show.tabs.info.priceForm.tva.label'));
        this.$tvaSelect = $('<select/>')
        .attr('name','tva')
        .addClass('form-control')
        .attr('required','required')
        .append(
             $('<option/>')
             .val('')
             .append('-')
        );

        let tvas = [
            5.5,
            20
        ];
        for(var i in tvas){
            let value = tvas[i];
            let label = window.formatFloat(value,2,',')+'%';

            let $option = $('<option/>')
            .val(value)
            .append(label);
            if(tva == value){
                $option.attr('selected','selected');
            }

            this.$tvaSelect.append($option);

        }
        let $tvaWarning = $('<small/>')
        .addClass('text-danger')
        .append(window.translate('app.product.show.tabs.info.priceForm.tva.warning'));
        if(tva || !this.product.id){
            $tvaWarning.hide();
        }
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($tvaLabel)
            .append(this.$tvaSelect)
            .append($tvaWarning)
        );


        //FIELD taxes
        let $taxAssociationsLabel = $('<label/>')
        .attr('for','taxAssociations')
        .append(window.translate('app.product.show.tabs.info.priceForm.taxAssociations.label'));
        let $taxesContainer = $('<div/>');


        let $template = $('<div/>')
        .addClass('row')
        .addClass('product-priceform-taxassociations-container');

        let $taxSelect = $('<select/>')
        .addClass('form-control')
        .attr('name','taxAssociations[][tax]')
        .append(
            $('<option/>')
            .val('')
            .append('')
        )
        for(var i in this.taxs){
            let tax = this.taxs[i].node;
            $taxSelect.append(
                $('<option/>')
                .val(tax.id)
                .append(tax.name)
            )            
        }

        let $inputAmountPerUnit = $('<input/>')
        .addClass('form-control')
        .attr('required','required')
        .attr('name','taxAssociations[][amountPerUnit]');

        $template
        .append(
            $('<div/>')
            .addClass('col-6')
            .append(window.translate('app.product.show.tabs.info.priceForm.taxAssociations.tax'))
            .append(' ')
            .append($taxSelect)
        )
        .append(
            $('<div/>')
            .addClass('col-6 ps-2')
            .append(window.translate('app.product.show.tabs.info.priceForm.taxAssociations.amountPerUnit'))
            .append(' ')
            .append($inputAmountPerUnit)
        )
        if(taxAssociations.length > 0){
            for(var i in taxAssociations){
                let taxAssociation = taxAssociations[i];
                let taxId = taxAssociation.tax.id;
                let amountPerUnit = taxAssociation.amountPerUnit;

                let $clone = $template.clone();

                let $currentTaxSelect = $('select[name="taxAssociations[][tax]"',$clone)
                .attr('name',"taxAssociations["+i+"][tax]");
                let $currentInputAmountPerUnit = $('input[name="taxAssociations[][amountPerUnit]',$clone)
                .attr('name',"taxAssociations["+i+"][amountPerUnit]");

                $('option[value="'+taxId+'"]',$currentTaxSelect).attr('selected','selected');
                $currentInputAmountPerUnit.val(amountPerUnit);

                $taxesContainer.append($clone);

            }
        }
        let $btnAddTaxAssociation = $('<button/>')
        .addClass('btn btn-sm btn-success btn-taxassociation-add mt-2')
        .append(window.translate('app.product.show.tabs.info.priceForm.taxAssociations.add'))
        .on('click',function(event){
            event.stopPropagation();
            event.preventDefault();

            let $clone = $template.clone();

            let i = $('.product-priceform-taxassociations-container').length;

            let $currentTaxSelect = $('select[name="taxAssociations[][tax]"',$clone)
            .attr('name',"taxAssociations["+i+"][tax]");
            let $currentInputAmountPerUnit = $('input[name="taxAssociations[][amountPerUnit]',$clone)
            .attr('name',"taxAssociations["+i+"][amountPerUnit]");

            $taxesContainer.append($clone);
        })
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .addClass('mb-2')
            .append($taxAssociationsLabel)
            .append($taxesContainer)
            .append(
                $('<div/>')
                .addClass('d-flex justify-content-center')
                .append($btnAddTaxAssociation)
            )
        )


        //FIELD sectorPriceUpdates
        let $sectorPriceUpdatesLabel = $('<label/>')
        .attr('for','sectorPriceUpdates')
        .append(window.translate('app.product.show.tabs.info.priceForm.sectorPriceUpdates.label'));        
        this.$sectorPriceUpdatesContainer = $("<div/>");
        this.$sectorPriceUpdatesWarning = $('<div/>')
        .append(
            $('<small/>')
            .addClass('d-flex justify-content-center text-warning')
            .append(window.translate('app.product.show.tabs.info.priceForm.sectorPriceUpdates.allSame'))
        ); 
        $box.append(
            $('<div/>')
            .addClass('form-group')
            .append($sectorPriceUpdatesLabel)
            .append(this.$sectorPriceUpdatesContainer)
            .append(this.$sectorPriceUpdatesWarning)
        )

        return $col;
    }

    getSupplierById(id){
        for(var i in this.suppliers){
            let supplier = this.suppliers[i].node;
            if(supplier.id == id){
                return supplier;
            }
        }
        return null;
    }

    getSectorPriceUpdate(sectorId){
        if(this.product.sectorPriceUpdates.length <= 0){
            return null;
        }
        for(var i in this.product.sectorPriceUpdates){
            let sectorPriceUpdate = this.product.sectorPriceUpdates[i];
            if(sectorPriceUpdate.sector.id == sectorId){
                return sectorPriceUpdate.price;
            }
        }
        return null;
    }

    onChangeSupplier(){
        let supplierId = this.$supplierSelect.val();

        this.$sectorPriceUpdatesContainer.html('');

        if(!supplierId){
            this.$sectorPriceUpdatesWarning.show();
            return;
        }

        let supplier = this.getSupplierById(supplierId);
        if(!supplier){
            this.$sectorPriceUpdatesWarning.show();
            return;
        }

        let sectors = supplier.sectors;
        if(sectors.length <= 0){
            this.$sectorPriceUpdatesWarning.show();
            return;
        }

        let hasAnyValue = false;
        for(var i in sectors){
            let sector = sectors[i];

            let inputId = 'sectorPriceUpdates'+sector.id;

            let $input = $('<input/>')
            .attr('id',inputId)
            .attr('name','sectorPriceUpdates['+sector.id+']')
            .addClass('form-control');

            let value = this.getSectorPriceUpdate(sector.id);
            if(value){
                hasAnyValue = true;
                $input.val(value)
            }


            let $line = $('<div/>')
            .addClass('sectorpriceupdate-line row mt-2')
            .append(
                $('<div/>')
                .addClass('col-6 d-flex justify-content-center')
                .append(
                    $("<small/>")
                    .attr('for',inputId)
                    .append(supplier.name + ' - ' + sector.name)
                )
            )
            .append(
                $('<div/>')
                .addClass('col-6')
                .append($input)
            );

            this.$sectorPriceUpdatesContainer.append($line);

        }

        this.$sectorPriceUpdatesWarning.hide();

    }


    onClickDeleteTechnicalFile(){
        var self = this;

        let $content = $('<div/>')
        .append(
            $('<div/>')
            .append(window.translate('app.product.show.tabs.info.infoForm.technicalFile.delete.confirm'))
        );

        let confirmModal = new ConfirmModal({
            'messageContent': $content,
            'btnConfirmClass': 'btn btn-danger btn-confirm',
            'btnCancelClass': 'btn btn-text text-secondary btn-cancel',
            'onConfirm': function(event){
                self.proceedDeleteTechnicalFile(confirmModal)
            },
            'onCancel': function(event,modal){
            }
        })
        confirmModal.show();
    }

    proceedDeleteTechnicalFile(confirmModal){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'product': {
                'value': this.product.id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplierProductTechnicalFile",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                confirmModal.dispose();
                window.notify(data.message,'success');
                self.refresh();
            },
            'error': function(message, xhr){
                confirmModal.dispose();
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = Form;

